import React from 'react';
import { isBrowser } from 'ws-scripts/modules/environment';
import logger from 'ws-scripts/modules/logger';
import { setNewRelicCustomAttribute } from 'ddc-new-relic';
import { ErrorBoundary } from 'wsm-error-boundary';
import PageTitle from '../components/PageTitle';

const Widget = () => {
	if (isBrowser) {
		const { pageTitle } =
			window.DDC.WidgetData['inventory-data-bus1'].props;

		return (
			<ErrorBoundary
				errorHandler={(error, errorInfo) => {
					setNewRelicCustomAttribute(
						'SRP ERROR',
						`ws-inv-page-title error boundary.\n${error}`
					);
					const newError = new Error(
						`ws-inv-page-title error boundary.\n${error}`
					);
					newError.originalError = error;
					newError.originalStackTrace = errorInfo.componentStack;
					logger.error(`${newError}\n${newError.originalStackTrace}`);
				}}
			>
				<PageTitle pageTitle={pageTitle} />
			</ErrorBoundary>
		);
	}
	return null;
};

export default Widget;
